export default function Footer() {
  return (
    <footer id="contacts" className="bg-[#1F2937] text-white py-12 sm:py-16 pb-24 lg:pb-16 border-t border-gray-700">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12 mb-8 sm:mb-12">
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-4">О компании</h3>
            <div className="space-y-2 text-sm text-gray-300">
              <p>ИНГ ВАР - Профессиональный сервис кранового оборудования ® 2006-2025.</p>
              <p className="mt-4">Все права защищены.</p>
            </div>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-bold mb-4">Контакты</h3>
            <div className="space-y-3 text-sm text-gray-300">
              <div className="flex items-center gap-3">
                <i className="ri-phone-line text-base"></i>
                <a href="tel:+78124081913" className="hover:text-white transition-colors cursor-pointer">
                  +7 (812) 408-1913
                </a>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-mail-line text-base mt-0.5"></i>
                <a href="mailto:sales+123805@engvar.ru" className="hover:text-white transition-colors cursor-pointer break-all">
                  sales+123805@engvar.ru
                </a>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-bold mb-4">Адрес</h3>
            <div className="space-y-2 text-sm text-gray-300">
              <p>ул. Мурзинская, д. 11,</p>
              <p>Санкт-Петербург, Россия, 190000</p>
            </div>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-bold mb-4">Правовая информация</h3>
            <div className="space-y-2 text-sm text-gray-300">
              <a href="#" className="block hover:text-white transition-colors cursor-pointer">
                Трудоустройство
              </a>
              <a href="#" className="block hover:text-white transition-colors cursor-pointer">
                Политика качества
              </a>
              <a href="#" className="block hover:text-white transition-colors cursor-pointer">
                Правовые уведомления
              </a>
              <a href="#" className="block hover:text-white transition-colors cursor-pointer">
                Политика конфиденциальности
              </a>
              <a href="#" className="block hover:text-white transition-colors cursor-pointer">
                Политика cookies
              </a>
            </div>
          </div>
        </div>

        <div className="pt-6 sm:pt-8 border-t border-gray-700 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-gray-400">
          <p className="text-center sm:text-left">© 2025 ИНГ ВАР. Все права защищены.</p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:text-white transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}